var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _path, _circle43, _circle44, _path2, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _path3, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _path4, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1200px",
    height: "1200px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "illustration_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60504B"
    },
    d: "M647.9,923.2V970c0,48.8,55.4,50.3,55.4,4.5v-51.8L647.9,923.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.3,
    y: 944.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.3,
    y: 952.9,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.3,
    y: 961.4,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60504B"
    },
    d: "M544.6,923.2V970c0,48.8,55.4,50.3,55.4,4.5v-51.8L544.6,923.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B1C9C3"
    },
    d: "M518.9,549c0,66.4,0,148.9,0,228.2c0,55.8,0,110,0,155.8c56.6,0,51.8,0,92.7,0 c0-46.8,0-101.4,0-154.5c0-75.9,0-148.8,0-191.6c5.9,0,20.5,0,25.9,0c0,41.3,0,115.8,0,191.6c0,54.9,0,110.4,0,154.5 c45,0,35.6,0,92.7,0c0-43,0-97.5,0-154.5c0-79.5,0-164,0-229.5H518.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 944.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 952.9,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 961.4,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60504B"
    },
    d: "M675,319.9c-27.8-13.5-68.3-15.8-101.3-0.1c-5.1-10.8-14-45.8-13.1-80.4 c1.1-40.5,15.5-80.5,65.3-80.4c47.8,0,61.8,39.1,62.5,79.7C688.4,271.8,675,319.9,675,319.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DF7977"
    },
    cx: 686.2,
    cy: 233.8,
    r: 12.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DF7977"
    },
    cx: 563.6,
    cy: 233.8,
    r: 12.1
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "jawMid_2_",
    cx: 625.5,
    cy: 284.1,
    r: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw7_2_",
    cx: 614.6,
    cy: 282.1,
    r: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw7_2_",
    cx: 636.4,
    cy: 282.1,
    r: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw3_2_",
    cx: 580.3,
    cy: 226.6,
    r: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw2_2_",
    cx: 580.3,
    cy: 217.1,
    r: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw3_2_",
    cx: 668.5,
    cy: 227,
    r: 0.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw2_2_",
    cx: 668.5,
    cy: 217.4,
    r: 0.8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "topMid_2_",
    cx: 624.7,
    cy: 166,
    r: 0.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "leftTop0_2_",
    cx: 642.4,
    cy: 168.5,
    r: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "rightTop0_2_",
    cx: 606.8,
    cy: 168.5,
    r: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60504B"
    },
    d: "M651.6,162.2c1.3-3.6,2.1-7.4,2.5-11.2c2.6,3.1,3.8,7.4,3.2,11.4c-0.1,0.7-0.3,1.5-0.7,2.1 c-0.7,0.9-1.9,1.2-3,1.4c-1.8,0.4-3.6,0.8-5.5,1C649.7,165.5,650.9,164.2,651.6,162.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60504B"
    },
    d: "M650.5,166.7c5.8-0.4,10.8-5.7,11-11.5c2.3,1,3.4,3.9,2.7,6.3c-0.7,2.4-2.9,4.2-5.3,4.9 c-2.4,0.7-5,0.4-7.4-0.3"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF4C68"
    },
    d: "M501.5,564.2c-1.3-73.2,11.7-128.9,32.3-167.4c12.6-23.6,28-40.7,44.8-51.6 c14.7-9.5,30.5-14.1,46.2-13.9c15.6,0.2,31.3,5.2,45.9,14.8c16.5,10.9,31.8,27.8,44.3,50.7c21.3,38.8,34.7,94.8,33.1,167.4H501.5 L501.5,564.2z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 741.4,
    y1: 564.8,
    x2: 508.6,
    y2: 564.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 625.4,
    cy: 351.3,
    rx: 22,
    ry: 16.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF9D"
    },
    d: "M616.2,277.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF9D"
    },
    d: "M614.2,265.7h20.9c0,0,4.3,61.7,5.7,85.2c-2.1,9.7-9.1,11.3-15.5,11.1c-8.2-0.2-15.9-4.7-17.1-12.5 L614.2,265.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD9B8E"
    },
    d: "M614.2,265.7h20.9c1.9,19-21.7,83.8-26.9,83.8L614.2,265.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F3AF9D"
    },
    cx: 625.2,
    cy: 228.3,
    rx: 56.4,
    ry: 57.6
  }), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "jawMid_1_",
    cx: 625.5,
    cy: 284.1,
    r: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw7_1_",
    cx: 614.6,
    cy: 282.1,
    r: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw7_1_",
    cx: 636.4,
    cy: 282.1,
    r: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw3_1_",
    cx: 580.3,
    cy: 226.6,
    r: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw2_1_",
    cx: 580.3,
    cy: 217.1,
    r: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw3_1_",
    cx: 668.5,
    cy: 227,
    r: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw2_1_",
    cx: 668.5,
    cy: 217.4,
    r: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "topMid_3_",
    cx: 624.7,
    cy: 166,
    r: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "leftTop0_3_",
    cx: 642.4,
    cy: 168.5,
    r: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "rightTop0_3_",
    cx: 606.8,
    cy: 168.5,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C323A"
    },
    d: "M578.7,221.9c3.1-6.1,13.1-6.7,21.1-6.1c0.7,2.3,0.7,3.8-0.1,3.7 C596.6,219.4,589.5,215.6,578.7,221.9z"
  }), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow1_1_",
    cx: 592.5,
    cy: 203.2,
    r: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow4_1_",
    cx: 615.8,
    cy: 206.2,
    r: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow3_1_",
    cx: 606,
    cy: 202.2,
    r: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow0_1_",
    cx: 588.5,
    cy: 206.9,
    r: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow2_1_",
    cx: 598.7,
    cy: 202.2,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C323A"
    },
    d: "M666.7,220.8c-7.5-3.4-8.8-2.2-19-1c-0.3-0.8-0.5-1.7-0.1-4c6,0.5,16-2.3,21.1,6.1 C668,221.5,667.4,221.1,666.7,220.8z"
  }), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow1_1_",
    cx: 656.2,
    cy: 203.6,
    r: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow4_1_",
    cx: 632.6,
    cy: 205.7,
    r: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow3_1_",
    cx: 642.6,
    cy: 202.5,
    r: 0.8
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow0_1_",
    cx: 660.2,
    cy: 206.5,
    r: 0.8
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow2_1_",
    cx: 649.9,
    cy: 202.1,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DF7977"
    },
    cx: 590.1,
    cy: 247.5,
    rx: 7.8,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2C323A"
    },
    cx: 593,
    cy: 231.6,
    rx: 3.6,
    ry: 5.8
  }), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye0_1_",
    cx: 594.7,
    cy: 215.1,
    r: 0.8
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye1_1_",
    cx: 599.9,
    cy: 211.4,
    r: 0.8
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye5_1_",
    cx: 599.9,
    cy: 217.4,
    r: 0.8
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye2_1_",
    cx: 606.2,
    cy: 211.4,
    r: 0.8
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye3_1_",
    cx: 611.4,
    cy: 215.6,
    r: 0.8
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye4_1_",
    cx: 606.2,
    cy: 216.6,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2C323A"
    },
    cx: 654.8,
    cy: 231.6,
    rx: 3.6,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DF7977"
    },
    cx: 659.2,
    cy: 247.5,
    rx: 7.8,
    ry: 6.2
  }), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye0_1_",
    cx: 654.3,
    cy: 215.1,
    r: 0.8
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye1_1_",
    cx: 649.1,
    cy: 211.4,
    r: 0.8
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye5_1_",
    cx: 649.1,
    cy: 217.4,
    r: 0.8
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye2_1_",
    cx: 642.8,
    cy: 211.4,
    r: 0.8
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye3_1_",
    cx: 637.6,
    cy: 215.6,
    r: 0.8
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye4_1_",
    cx: 642.8,
    cy: 216.6,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rightMiddleLip_2_",
    d: "M610.8,254.6c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S610.4,254.6,610.8,254.6z"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    id: "upperLipBottomMid_1_",
    cx: 624.5,
    cy: 255.1,
    r: 0.8
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipBottom1_1_",
    cx: 620.6,
    cy: 254.6,
    r: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "leftMiddleLip_2_",
    d: "M638.2,254.6c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S637.8,254.6,638.2,254.6z"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipBottom1_1_",
    cx: 628.4,
    cy: 254.6,
    r: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C323A",
      stroke: "#2C323A",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M611.6,255.4c0,0,7.4-0.2,12.9-0.2 s13.9-0.1,13.9-0.1s-6.1,4-13.9,4C616.6,259.1,611.6,255.4,611.6,255.4z"
  }), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipTopMid_2_",
    cx: 624.5,
    cy: 258.1,
    r: 0.8
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipTop0_2_",
    cx: 620.6,
    cy: 257.4,
    r: 0.8
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipTop0_2_",
    cx: 628.4,
    cy: 257.4,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60504B"
    },
    d: "M636.7,182.2c-0.2,8.5-8.4,18.8-25.9,23.3c-2.1,0.5,9-8.2,13.7-18.5 c-19.7,23.6-29.8,27.3-63.8,25.6c5.1-22.7,26.3-53.3,63.3-53.7s57.1,21.6,65.1,56.3C667.2,210.1,649.5,212.2,636.7,182.2z"
  }), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    id: "jawMid_3_",
    cx: 625.5,
    cy: 284.1,
    r: 0.8
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw7_3_",
    cx: 614.6,
    cy: 282.1,
    r: 0.8
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw7_3_",
    cx: 636.4,
    cy: 282.1,
    r: 0.8
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw3_3_",
    cx: 580.3,
    cy: 226.6,
    r: 0.8
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw2_3_",
    cx: 580.3,
    cy: 217.1,
    r: 0.8
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw3_3_",
    cx: 668.5,
    cy: 227,
    r: 0.8
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw2_3_",
    cx: 668.5,
    cy: 217.4,
    r: 0.8
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    id: "topMid_1_",
    cx: 624.7,
    cy: 166,
    r: 0.8
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    id: "leftTop0_1_",
    cx: 642.4,
    cy: 168.5,
    r: 0.8
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    id: "rightTop0_1_",
    cx: 606.8,
    cy: 168.5,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF9D"
    },
    d: "M968.4,381.4l17-6.8c0,0,6.1,5.5,13,11.2s-4.7,18.4-15.3,10.6C972.4,388.6,968.4,381.4,968.4,381.4z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E094A3"
    },
    d: "M410.4,322.3l3,56.8c58.9,0.3,93.5-2.3,119.3,17.7l48.7-50.2C527.1,319.9,466.4,318.9,410.4,322.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E094A3"
    },
    d: "M670.3,345.6l43.3,53.2c27-16.2,67.7-16.3,126.6-16.7v-56.8C784.2,321.9,741,314.9,670.3,345.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF9D"
    },
    d: "M415.6,328.9c-47.7,2.7-123.1,8.9-160.2,14.2c-37.1,5.3-40.1,40.1,5.3,39.5s95.2-3.5,159.7-12.1 L415.6,328.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF9D"
    },
    d: "M280.2,381.4l-17-6.8c0,0-6.1,5.5-13,11.2s4.7,18.4,15.3,10.6C276.2,388.6,280.2,381.4,280.2,381.4z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF9D"
    },
    d: "M834.3,373.5c64.5,8.6,113.3,11.5,158.7,12.1s42.4-34.2,5.3-39.5c-37.1-5.3-114.5-11.5-162.2-14.2 L834.3,373.5z"
  }), /*#__PURE__*/React.createElement("g", null, _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    id: "nose1_1_",
    cx: 623.7,
    cy: 216.1,
    r: 0.8
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    id: "nose0_1_",
    cx: 623.7,
    cy: 210.3,
    r: 0.8
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    id: "nose3_1_",
    cx: 623.7,
    cy: 228.7,
    r: 0.8
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    id: "rightNose0_1_",
    cx: 613,
    cy: 233.2,
    r: 0.8
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    id: "rightNose1_1_",
    cx: 618.2,
    cy: 233.2,
    r: 0.8
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    id: "nose2_1_",
    cx: 623.7,
    cy: 221.6,
    r: 0.8
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    id: "nose4_1_",
    cx: 623.7,
    cy: 234,
    r: 0.8
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    id: "leftNose0_1_",
    cx: 634.1,
    cy: 233.2,
    r: 0.8
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    id: "leftNose1_1_",
    cx: 629.3,
    cy: 233.2,
    r: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C323A",
      stroke: "#2C323A",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M622.4,232.8c-1.2,0-4.6,1.6-5.8,5.2 c-0.2,1.2,0.6,5.8,6,4.1c-0.1-1-4.7-1.1-4.5-3.7C618.4,236.6,620.1,236.6,622.4,232.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "skeleton_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "518.8,349.5 569.1,565.3 685.5,564.5 731.7,349.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "517.8,349.5 415.1,349.5 251.8,355.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "733.2,349.1 836.4,349.1 999.7,355.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "569.1,565.3 575.5,725.5 575.5,933.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "685.5,564.5 685.5,725.5 685.5,933.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "624.5,170 604.7,172.5 592.2,182 583.6,196.1  581.1,205.4 580.3,217.1 580.3,226.6 581.1,248.3 587.9,268.3 599.5,280.8 609.5,287.5 624.5,290.7 639.3,287.9 649.3,281.2  660.9,268.6 667.7,248.6 668.5,227 668.5,217.4 667.7,205.7 665.2,196.5 657,182 644.4,172.5 624.5,170  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "588.5,206.9 592.5,203.2 598.7,202.2 606,202.2  615.8,206.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "594.7,215.1 599.9,211.4 606.2,211.4 611.4,215.6  606.2,216.6 599.9,217.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "613,233.2 618.2,233.2 623.7,234 623.7,228.7  623.7,221.6 623.7,216.1 623.7,210.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "660,206.5 656,203.6 649.7,202.1 642.4,202.5  632.4,205.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "654.1,215.1 648.8,211.4 642.5,211.4 637.4,215.6  642.5,216.6 648.8,217.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "634.1,233.2 629.1,233.2 623.7,234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "607,255.3 613.9,251.9 620.4,250.8 624.5,251.7  628.7,250.8 635.1,251.9 642,255.3 635.6,261.6 628.5,264.4 624.5,264.9 620.4,264.4 613.4,261.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "607,255.3 610.6,255.6 620.6,254.8 624.5,255.3  628.5,254.8 638.4,255.6 642,255.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "607,255.3 610.6,255.6 620.6,257.7 624.5,258.5  628.5,257.7 638.4,255.6 642,255.3  "
  }), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    id: "rightShoulder",
    cx: 518.9,
    cy: 349.2,
    r: 8.2
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    id: "rightElbow",
    cx: 415.4,
    cy: 349.3,
    r: 8.2
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    id: "rightWrist",
    cx: 252,
    cy: 355.7,
    r: 8.2
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    id: "rightHip",
    cx: 569.2,
    cy: 565,
    r: 8.2
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    id: "rightKnee",
    cx: 575.6,
    cy: 725.2,
    r: 8.2
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    id: "rightAnkle",
    cx: 575.6,
    cy: 933.2,
    r: 8.2
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    id: "leftElbow",
    cx: 836.2,
    cy: 348.9,
    r: 8.2
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    id: "leftWrist",
    cx: 999.6,
    cy: 355.2,
    r: 8.2
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    id: "leftHip",
    cx: 685.6,
    cy: 564.2,
    r: 8.2
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    id: "leftKnee",
    cx: 685.6,
    cy: 725.2,
    r: 8.2
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    id: "leftAnkle",
    cx: 685.6,
    cy: 933.2,
    r: 8.2
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye0",
    cx: 594.7,
    cy: 215.1,
    r: 0.8
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow1",
    cx: 592.5,
    cy: 203.2,
    r: 0.8
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow4",
    cx: 615.8,
    cy: 206.2,
    r: 0.8
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    id: "nose1",
    cx: 623.7,
    cy: 216.1,
    r: 0.8
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow3",
    cx: 606,
    cy: 202.2,
    r: 0.8
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye1",
    cx: 599.9,
    cy: 211.4,
    r: 0.8
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow0",
    cx: 588.5,
    cy: 206.9,
    r: 0.8
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow2",
    cx: 598.7,
    cy: 202.2,
    r: 0.8
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye5",
    cx: 599.9,
    cy: 217.4,
    r: 0.8
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye2",
    cx: 606.2,
    cy: 211.4,
    r: 0.8
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye3",
    cx: 611.4,
    cy: 215.6,
    r: 0.8
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    id: "nose0",
    cx: 623.7,
    cy: 210.3,
    r: 0.8
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    id: "nose3",
    cx: 623.7,
    cy: 228.7,
    r: 0.8
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    id: "rightNose0",
    cx: 613,
    cy: 233.2,
    r: 0.8
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    id: "rightMouthCorner",
    cx: 607,
    cy: 255.3,
    r: 0.8
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    id: "rightNose1",
    cx: 618.2,
    cy: 233.2,
    r: 0.8
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipTop0",
    cx: 613.9,
    cy: 251.9,
    r: 0.8
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    id: "nose2",
    cx: 623.7,
    cy: 221.6,
    r: 0.8
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    id: "nose4",
    cx: 623.7,
    cy: 234,
    r: 0.8
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    id: "upperLipTopMid",
    cx: 624.5,
    cy: 251.7,
    r: 0.8
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipTop1",
    cx: 620.4,
    cy: 250.8,
    r: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "rightMiddleLip",
    d: "M610.6,254.8c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S610.2,254.8,610.6,254.8z "
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipBottomMid",
    cx: 624.5,
    cy: 264.9,
    r: 0.8
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    id: "upperLipBottomMid",
    cx: 624.5,
    cy: 255.3,
    r: 0.8
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipTopMid",
    cx: 624.5,
    cy: 258.4,
    r: 0.8
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipBottom1",
    cx: 620.6,
    cy: 254.8,
    r: 0.8
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipTop0",
    cx: 620.6,
    cy: 257.7,
    r: 0.8
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipBottom1",
    cx: 620.4,
    cy: 264.4,
    r: 0.8
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipBottom0",
    cx: 613.4,
    cy: 261.6,
    r: 0.8
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye4",
    cx: 606.2,
    cy: 216.6,
    r: 0.8
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    id: "jawMid",
    cx: 624.5,
    cy: 290.7,
    r: 0.8
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw7",
    cx: 609.5,
    cy: 287.5,
    r: 0.8
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw6",
    cx: 599.5,
    cy: 280.8,
    r: 0.8
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw5",
    cx: 587.9,
    cy: 268.3,
    r: 0.8
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw4",
    cx: 581.1,
    cy: 248.3,
    r: 0.8
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw3",
    cx: 580.3,
    cy: 226.6,
    r: 0.8
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw2",
    cx: 580.3,
    cy: 217.1,
    r: 0.8
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw1",
    cx: 581.1,
    cy: 205.4,
    r: 0.8
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw0",
    cx: 583.6,
    cy: 196.1,
    r: 0.8
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    id: "topMid",
    cx: 624.7,
    cy: 170,
    r: 0.8
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    id: "leftTop0",
    cx: 644.4,
    cy: 172.5,
    r: 0.8
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    id: "leftTop1",
    cx: 657,
    cy: 182,
    r: 0.8
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye0",
    cx: 654.3,
    cy: 215.1,
    r: 0.8
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow1",
    cx: 656.2,
    cy: 203.6,
    r: 0.8
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow4",
    cx: 632.6,
    cy: 205.7,
    r: 0.8
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow3",
    cx: 642.6,
    cy: 202.5,
    r: 0.8
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye1",
    cx: 649.1,
    cy: 211.4,
    r: 0.8
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow0",
    cx: 660.2,
    cy: 206.5,
    r: 0.8
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow2",
    cx: 649.9,
    cy: 202.1,
    r: 0.8
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye5",
    cx: 649.1,
    cy: 217.4,
    r: 0.8
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye2",
    cx: 642.8,
    cy: 211.4,
    r: 0.8
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye3",
    cx: 637.6,
    cy: 215.6,
    r: 0.8
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    id: "leftNose0",
    cx: 634.1,
    cy: 233.2,
    r: 0.8
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    id: "leftMouthCorner",
    cx: 642,
    cy: 255.3,
    r: 0.8
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    id: "leftNose1",
    cx: 629.3,
    cy: 233.2,
    r: 0.8
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipTop0",
    cx: 635.1,
    cy: 251.9,
    r: 0.8
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipTop1",
    cx: 628.7,
    cy: 250.8,
    r: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "leftMiddleLip",
    d: "M638.4,254.8c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S638,254.8,638.4,254.8z"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipBottom1",
    cx: 628.5,
    cy: 254.8,
    r: 0.8
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipTop0",
    cx: 628.5,
    cy: 257.7,
    r: 0.8
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipBottom1",
    cx: 628.7,
    cy: 264.4,
    r: 0.8
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipBottom0",
    cx: 635.6,
    cy: 261.6,
    r: 0.8
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye4",
    cx: 642.8,
    cy: 216.6,
    r: 0.8
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw7",
    cx: 639.3,
    cy: 287.9,
    r: 0.8
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw6",
    cx: 649.3,
    cy: 281.2,
    r: 0.8
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw5",
    cx: 660.9,
    cy: 268.6,
    r: 0.8
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw4",
    cx: 667.7,
    cy: 248.6,
    r: 0.8
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw3",
    cx: 668.5,
    cy: 227,
    r: 0.8
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw2",
    cx: 668.5,
    cy: 217.4,
    r: 0.8
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw1",
    cx: 667.7,
    cy: 205.7,
    r: 0.8
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw0",
    cx: 665.2,
    cy: 196.5,
    r: 0.8
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    id: "rightTop0",
    cx: 604.8,
    cy: 172.5,
    r: 0.8
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    id: "rightTop1",
    cx: 592.2,
    cy: 182,
    r: 0.8
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    id: "leftShoulder",
    cx: 731.8,
    cy: 349.2,
    r: 8.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/girl.43194de126d520c5680189a7d5e3f541.svg";
export { ForwardRef as ReactComponent };